const single_sign_on = {
    forbidden_domains: '不允许使用公共电子邮件域名。',
    duplicated_domains: '存在重复的域名。',
    /** UNTRANSLATED */
    invalid_domain_format: 'Invalid domain format.',
    /** UNTRANSLATED */
    duplicate_connector_name: 'Connector name already exists. Please choose a different name.',
};
export default Object.freeze(single_sign_on);
